import { useUserConfiguration } from "@hooks/useUserConfiguration.ts";
import type { UserConfigurationType } from "@hooks/useUserConfiguration.ts";

const DECISION = "decision";
const REPORT = "report";

export const hasLoginEvaluations = ({ isFeatureEnabled }: UserConfigurationType): boolean =>
  isFeatureEnabled("third_party_login_evaluations", REPORT) ||
  isFeatureEnabled("third_party_login_evaluations", DECISION);

export const hasInfoUpdateEvaluations = ({ isFeatureEnabled }: UserConfigurationType): boolean =>
  isFeatureEnabled("third_party_info_update_evaluations", REPORT) ||
  isFeatureEnabled("third_party_info_update_evaluations", DECISION);

const hasGuardPermission = ({ permissions }: UserConfigurationType): boolean =>
  permissions.includes("backoffice.view_deviceevaluation");

export const canViewGuard = (configuration: UserConfigurationType): boolean =>
  (hasLoginEvaluations(configuration) || hasInfoUpdateEvaluations(configuration)) &&
  hasGuardPermission(configuration);

export function useGuardEnabled(): {
  canViewGuard: boolean;
  canViewLoginEvaluations: boolean;
  canViewInfoUpdateEvaluations: boolean;
} {
  const configuration = useUserConfiguration();

  return {
    canViewGuard: canViewGuard(configuration),
    canViewLoginEvaluations:
      hasLoginEvaluations(configuration) && hasGuardPermission(configuration),
    canViewInfoUpdateEvaluations:
      hasInfoUpdateEvaluations(configuration) && hasGuardPermission(configuration),
  };
}
